import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export interface LineRequest {
  id?: string | null;
  name?: string | null;
  areaId?: string | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AreaNewResponse {
  id: string;
  name: string;
}

export interface SublineResponse {
  id: string;
  name: string;
}

export interface LineResponse {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: string | null;
  updatedBy?: string | null;
  areaId?: string | null;
  area?: AreaNewResponse | null;
  subLines?: SublineResponse[];
}

export default class LineApi {
  static async GetAllLines(): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/lines/all`);
  }

  static async GetLinesByArea(areaId: string): Promise<any> {
    return ApiHandler(baseURL).get(
      `/v1/lines/area/${encodeURIComponent(areaId)}`,
    );
  }

  static async GetLinesByPlant(plantId: string): Promise<any> {
    return ApiHandler(baseURL).get(
      `/v1/lines/plant/${encodeURIComponent(plantId)}`,
    );
  }

  static async GetLineById(id: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/lines/${encodeURIComponent(id)}`);
  }

  static async GetByFilterAsync(
    plantIds: string[],
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "name",
    sortDirection: string = "asc",
    code?: string,
    name?: string,
    productionUnitName?: string,
    areaIds?: string[],
    productionUnitIds?: string[],
    version?: number,
  ): Promise<any> {
    let url = `/v1/lines/filter?`;

    plantIds?.forEach((id) => {
      url += `plantIds=${encodeURIComponent(id)}&`;
    });

    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    if (code) url += `&code=${encodeURIComponent(code)}`;
    if (name) url += `&name=${encodeURIComponent(name)}`;
    if (productionUnitName) url += `&productionUnitName=${encodeURIComponent(productionUnitName)}`;
    if (version !== undefined) url += `&version=${encodeURIComponent(String(version))}`;

    areaIds?.forEach((id) => {
      url += `&areaIds=${encodeURIComponent(id)}`;
    });
    productionUnitIds?.forEach((id) => {
      url += `&productionUnitIds=${encodeURIComponent(id)}`;
    });

    return ApiHandler(baseURL).get(url);
  }

  static async Create(line: LineRequest): Promise<any> {
    return ApiHandler(baseURL).post(`/v1/lines`, line);
  }

  static async Update(id: string, line: LineRequest): Promise<any> {
    return ApiHandler(baseURL).put(`/v1/lines/${encodeURIComponent(id)}`, line);
  }

  static async Delete(id: string): Promise<any> {
    return ApiHandler(baseURL).delete(`/v1/lines/${encodeURIComponent(id)}`, {
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    });
  }
}
